
import service from "../services/payments.service"; // Asegúrate de que el servicio esté configurado correctamente

export const payments = {
    namespaced: true,
    state: {
        
    },
    getters: {
        
    },
    actions: {
        async getAll() {
            try {
                const response = await service.getAll();
                return response;
            } catch (error) {
                console.error("Error fetching proyects:", error);
            }
        },
        async create() {
            try {
                const response = await service.create();
                return response;
            } catch (error) {
                console.error("Error fetching proyects:", error);
            }
        },
        async get() {
            try {
                const response = await service.get();
                return response.data;
            } catch (error) {
                console.error("Error fetching proyects:", error);
            }
        },
        
    },
    mutations: {
        
    },
};